import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "./commonLanguageHeader";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface RouteHistoryParams {
  vehicleId: string | number;
  date: string;
  startHour: number;
  endHour: number;
}

export interface RouteHistoryPoint {
  timestamp?: string;
  latitude?: number | string | null;
  longitude?: number | string | null;
  speed?: number | string | null;
  routeStart?: boolean;
  routeEnd?: boolean;
}

export const getRouteHistoryByVehicleId = (
  params: RouteHistoryParams,
  language?: string,
) =>
  ApiService.get<{ response: RouteHistoryPoint[] }>(
    `${ServicesUrlEndpoints.ROUTE_RAW_DATA}/${params.vehicleId}`,
    {
      ...getLanguageHeaders(language),
      params: {
        date: params.date,
        startHour: params.startHour,
        endHour: params.endHour,
      },
    },
  );
